import React from 'react'
import { Button, Result } from 'antd'
import { useIntl } from 'react-intl'

export default function InterviewLinkError({ messageId = 'interviewLinkInvalid', retryable = false }) {
  const intl = useIntl()
  return (
    <div role="alert">
      <Result
        status={retryable ? 'warning' : 'error'}
        title={intl.formatMessage({ id: messageId })}
        extra={retryable ? <Button onClick={() => window.location.reload()}>{intl.formatMessage({ id: 'interviewRetry' })}</Button> : null}
      />
    </div>
  )
}
